/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updatedHierarchy = /* GraphQL */ `
  subscription UpdatedHierarchy {
    updatedHierarchy {
      result
      hiers {
        agentNum
        AgencyCode
        ManagerAgentNumPrimary
        AOAgentNumPrimary
        GLHierarchyTypeRoleID
        IsUnassigned
        CreatedBy
      }
    }
  }
`;
export const onRevoke = /* GraphQL */ `
  subscription OnRevoke {
    onRevoke {
      id
      FirstName
      MiddleName
      LastName
      TMKClientID
      AgencyCode
      AgentNum
      AgentNumPrimary
      ManagerAgentNumPrimary
      AOAgentNumPrimary
      IsUnassigned
      ModifiedDate
      RoleId
      RoleAbbr
      TerminationDate
    }
  }
`;
export const onUnlock = /* GraphQL */ `
  subscription OnUnlock {
    onUnlock {
      AOAgentNum
      Msg
      Editing
      From
      FromName
      To
      FromSession
      ToSession
    }
  }
`;
